import util from '../util'

const controller = 'v1/PainelAcompanhamentoFraudes'
const DATA_REFERENCIA = new Date('2026-07-21T00:00:00')

function normalizarData (value) {
  if (!value) return null
  if (value instanceof Date) return new Date(value.getFullYear(), value.getMonth(), value.getDate())
  if (typeof value === 'string' && value.indexOf('/') > -1) {
    const partes = value.split('/')
    return new Date(Number(partes[2]), Number(partes[1]) - 1, Number(partes[0]))
  }
  const data = new Date(value)
  if (Number.isNaN(data.getTime())) return null
  return new Date(data.getFullYear(), data.getMonth(), data.getDate())
}

function formatarDataParametro (value) {
  const data = normalizarData(value)
  if (!data) return null
  const ano = data.getFullYear()
  const mes = String(data.getMonth() + 1).padStart(2, '0')
  const dia = String(data.getDate()).padStart(2, '0')
  return `${ano}-${mes}-${dia}`
}

function periodoParaFaixa (periodo) {
  const fim = new Date(DATA_REFERENCIA.getFullYear(), DATA_REFERENCIA.getMonth(), DATA_REFERENCIA.getDate())
  const inicio = new Date(fim)

  if (periodo === 'ultimos3Meses') {
    inicio.setMonth(fim.getMonth() - 2, 1)
  } else if (periodo === 'ultimos6Meses') {
    inicio.setMonth(fim.getMonth() - 5, 1)
  } else if (periodo === 'ultimoAno') {
    inicio.setMonth(fim.getMonth() - 11, 1)
  } else {
    inicio.setDate(1)
  }

  inicio.setHours(0, 0, 0, 0)

  return {
    dataInicio: inicio,
    dataFim: fim,
    agrupamento: periodo === 'mesAtual' || !periodo ? 'Diario' : 'Mensal'
  }
}

function obterFiltroNormalizado (dto) {
  const faixa = dto.dataInicio && dto.dataFim
    ? {
      dataInicio: normalizarData(dto.dataInicio),
      dataFim: normalizarData(dto.dataFim),
      agrupamento: dto.agrupamento || 'Mensal'
    }
    : periodoParaFaixa(dto.periodo)

  return {
    codigoParceiro: dto.codigoParceiro || null,
    codigoAgencia: dto.codigoAgencia || null,
    codigoConta: dto.codigoConta || null,
    numeroConta: dto.contaText || null,
    dataInicio: faixa.dataInicio,
    dataFim: faixa.dataFim,
    agrupamento: dto.agrupamento || faixa.agrupamento,
    busca: dto.busca || null,
    dtInicio: dto.dtInicio || null,
    dtFim: dto.dtFim || null,
    situacaoReporte: dto.situacaoReporte,
    situacaoPrazo: dto.situacaoPrazo
  }
}

function adicionarParametro (parameters, name, value) {
  if (value === undefined) return
  parameters.push({ name, value })
}

function construirDto (dto, options) {
  const filtro = obterFiltroNormalizado(dto || {})
  const parameters = []

  adicionarParametro(parameters, 'codigoParceiro', filtro.codigoParceiro)
  adicionarParametro(parameters, 'codigoAgencia', filtro.codigoAgencia)
  adicionarParametro(parameters, 'codigoConta', filtro.codigoConta)
  adicionarParametro(parameters, 'numeroConta', filtro.numeroConta)
  adicionarParametro(parameters, 'DataInicio', formatarDataParametro(filtro.dataInicio))
  adicionarParametro(parameters, 'DataFim', formatarDataParametro(filtro.dataFim))
  adicionarParametro(parameters, 'Agrupamento', filtro.agrupamento)
  adicionarParametro(parameters, 'dtInicio', formatarDataParametro(filtro.dtInicio))
  adicionarParametro(parameters, 'dtFim', formatarDataParametro(filtro.dtFim))
  adicionarParametro(parameters, 'SituacaoReporte', filtro.situacaoReporte)
  adicionarParametro(parameters, 'SituacaoPrazo', filtro.situacaoPrazo)
  adicionarParametro(parameters, 'Busca', filtro.busca)

  return {
    parameters,
    data: options && options.data ? options.data : undefined
  }
}

function normalizarIndicadores (data) {
  return {
    fraudesIdentificadas: data && data.fraudesIdentificadas ? data.fraudesIdentificadas : 0,
    rc06Registradas: data && data.rc06Registradas ? data.rc06Registradas : 0,
    pendentesReporte: data && data.pendentesReporte ? data.pendentesReporte : 0,
    coberturaReporte: data && data.coberturaReporte ? data.coberturaReporte : 0,
    reportadosNoPrazo: data && data.reportadosNoPrazo ? data.reportadosNoPrazo : 0,
    reportadosForaDoPrazo: data && data.reportadosForaDoPrazo ? data.reportadosForaDoPrazo : 0,
    pendentesNoPrazo: data && data.pendentesNoPrazo ? data.pendentesNoPrazo : 0,
    pendentesVencidos: data && data.pendentesVencidos ? data.pendentesVencidos : 0,
    prazoMedio: data && data.prazoMedio ? data.prazoMedio : '-'
  }
}

function normalizarDesempenho (data) {
  return Array.isArray(data) ? data.map(item => ({
    codigoParceiro: item.codigoParceiro,
    parceiro: item.parceiro,
    identificadas: item.identificadas || 0,
    reportadas: item.reportadas || 0,
    pendentes: item.pendentes || 0,
    foraDoPrazo: item.foraDoPrazo || 0,
    cobertura: item.cobertura || 0
  })) : []
}

export default {
  GetIndicadores: function (dto) {
    return util.Axios.GetAll(controller + '/indicadores', construirDto(dto)).then(normalizarIndicadores)
  },

  GetEvolucaoMensal: function (dto) {
    return util.Axios.GetAll(controller + '/evolucao', construirDto(dto)).then(data => (Array.isArray(data) ? data : []))
  },

  GetConformidade: function (dto) {
    return util.Axios.GetAll(controller + '/conformidade', construirDto(dto))
  },

  GetDesempenhoParceiros: function (dto) {
    return util.Axios.GetAll(controller + '/desempenho-parceiros', construirDto(dto)).then(normalizarDesempenho)
  },

  GetIndicios: function (dto, options) {
    return util.Axios.GetAll(controller + '/indicios', construirDto(dto, options))
  },

  GetDetalhe: function (idInfracao) {
    return util.Axios.Get(controller + '/indicios', idInfracao)
  },

  ImportarArquivo: function (formData) {
    return util.Axios.PostForm(controller + '/ExtrairInformacoesArquivo', formData)
  },

  GetHistoricoImportacao: function (dto, options) {
    return util.Axios.GetAll(controller + '/ArquivosImportados', construirDto(dto, options))
  },

  ObterDadosCriacaoOcorrenciaRC06: function (codigo) {
    return util.Axios.Get(controller + '/indicios/' + codigo + '/DadosCriacaoOcorrenciaRC06')
  },

  EnviarOcorrenciaRC06: function (codigo, dto) {
    return util.Axios.Post(controller + '/indicios/' + codigo + '/EnviarOcorrenciaRC06', dto)
  },

  SincronizarOcorrenciasRC06: function () {
    return util.Axios.Post(controller + '/sincronizar')
  }
}
